import { createRealtimeStore } from "@stores/shared/createRealtimeStore";
import { REALTIME_EVENTS } from "@config/shared/realtime-events";
import useNotificationsStore from "@stores/shared/useNotificationsStore";

const fetchNotifications = () => useNotificationsStore.getState().fetchItems();

// Notification push (ADR-0051). NotificationsChanged carries no content, only "your list
// changed", so the list is fetched again from the API, which decides what the user may see.
// Every (re)connect fetches too: whatever was sent while this tab was offline or hidden was
// missed. Only while watched: by a signed-in user whose role has notifications.
export const createNotificationChannelStore = (connection, refetch = fetchNotifications) =>
  createRealtimeStore({
    name: "notificationChannel",
    initialState: { watching: false },
    connection,
    events: {
      [REALTIME_EVENTS.NOTIFICATIONS_CHANGED]: (set, get) => () => get().refetch(),
    },
    onConnected: (set, get) => get().refetch(),
    additionalActions: (set, get) => ({
      refetch: () => (get().watching ? refetch() : undefined),
      // Returns unwatch(), like holdOpen() returns release().
      watch: () => {
        set({ watching: true });
        return () => set({ watching: false });
      },
    }),
  });

const useNotificationChannelStore = createNotificationChannelStore();

export default useNotificationChannelStore;
